import { createSelector } from 'reselect';
import {
  ROUTE_INSTITUTION_HOMEPAGE,
  ROUTE_INSTITUTION_PAGE,
  ROUTE_COURSE_PAGE,
  ROUTE_INSTITUTION_QUALIFICATION_PAGE,
  ROUTE_INSTITUTION_SUBSCRIPTIONS_PAGE,
} from '../../routeActions';
import { selectType, selectState } from '../../location/selectors';

export const selectCurrentInstitutionPrefixFromRoute = createSelector(
  selectType,
  selectState,
  (type, state) => {
    switch (type) {
      case ROUTE_COURSE_PAGE:
      case ROUTE_INSTITUTION_HOMEPAGE:
      case ROUTE_INSTITUTION_QUALIFICATION_PAGE:
      case ROUTE_INSTITUTION_SUBSCRIPTIONS_PAGE:
      case ROUTE_INSTITUTION_PAGE: {
        return state.get('institutionPrefix')
          ? state.get('institutionPrefix').toLowerCase()
          : null;
      }
      default: {
        return null; // A routing action for another page
      }
    }
  }
);
